import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { useAppSelector } from '../../app/store/hooks';
import { useConnect } from '../../core/UpConnect/UpConnect';
import styles from './OpenOnUpliance.module.css';

const OpenOnUpliance = () => {
  const { deviceTask, deviceTaskStatus, openRecipe, cancelOpeningRecipe, openRecipeLoading, cancelOpeningRecipeLoading } = useConnect();
  const recipe = useAppSelector((state) => state.recipePage.recipe);

  if (!recipe?.id) return null;
  if (deviceTask?.metadata?.recipeId === recipe?.id && deviceTaskStatus === 'PENDING') {
    return <button className={styles.open_on_upliance} onClick={() => cancelOpeningRecipe(recipe.id, recipe.metadata.name)} type='button'>
      <Typography variant="captionparalell">Cancel</Typography>
      {cancelOpeningRecipeLoading ? <div><span>&nbsp;&nbsp;&nbsp;</span><CircularProgress size={18} /></div> : null}
    </button>
  }
  return (
    <button className={styles.open_on_upliance} onClick={() => openRecipe(recipe.id, recipe.metadata.name)} type='button'>
      <Typography variant="captionparalell">Open on upliance</Typography>
      {openRecipeLoading ? <div className={styles.loader_container}><span>&nbsp;&nbsp;&nbsp;</span><CircularProgress size={18} /></div> : null}
    </button>
  )
}

export default OpenOnUpliance;